import { message } from 'antd';
import i18n from '../../i18n';
import { fetchReportStatus, fetchReportKinds } from '../../services/reportStatus';
import { setTableData, setIsLoading, setReportKinds } from '../actions/reportStatus';

export const loadReportKinds = () => async (dispatch) => {
  try {
    const response = await fetchReportKinds();
    dispatch(setReportKinds(response.data || []));
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  }
};

export const loadReportStatus = (selectors) => async (dispatch) => {
  dispatch(setIsLoading(true));
  const params = new URLSearchParams();

  Object.entries(selectors).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) params.append(key, value.join(','));
    } else if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  try {
    const response = await fetchReportStatus(params.toString());
    dispatch(setTableData(response.data || []));
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  } finally {
    dispatch(setIsLoading(false));
  }
};
